import React, { useState } from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import API_BASE_URL from '../../ApiConfig/ApiConfig';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [showSuccess, setShowSuccess] = useState(false); // State for success message visibility
  const [showError, setShowError] = useState(false); // State for error message visibility

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    setShowSuccess(false); // Hide success message if any previous success is shown
    setShowError(false); // Hide previous error message if any

    try {
      await axios.post(`${API_BASE_URL}/api/users/forgot-password`, { email });
      setMessage('Password reset link sent to your email address.');
      setShowSuccess(true); // Show success modal
      setTimeout(() => {
        setShowSuccess(false); // Hide success modal after 3 seconds
      }, 3000);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to send reset link. Please try again.');
      setShowError(true); // Show error modal
      setTimeout(() => {
        setShowError(false); // Hide error modal after 3 seconds
      }, 3000);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-[#FAF9FF]">
      <div className="flex flex-col lg:flex-row bg-white shadow-lg overflow-hidden w-10/12 max-w-4xl rounded-2xl">
        {/* Left Section with Image */}
        <div className="flex justify-center items-center w-full lg:w-1/2 bg-white overflow-hidden rounded-t-2xl lg:rounded-s-2xl h-[50%] lg:h-full">
          <img src="/auth-page-images/Layer_1 Forgot Password.svg" alt="Illustration" className="w-full h-full object-cover" />
        </div>

        {/* Right Section with Form */}
        <div className="w-full lg:w-1/2 p-8 mt-6 lg:mt-24 rounded-b-2xl lg:rounded-e-2xl">
          <img src="/auth-page-images/securent 1.svg" alt="SecureNet Logo" className="mx-auto mb-6 h-8" />
       

          <form onSubmit={handleSubmit} className="pt-4">
            <div className="mb-6 relative">
              <input
                type="email"
                id="email"
                className="w-full p-2 pl-10 text-[#1C50A3] bg-[#E2EDFF80] rounded-md focus:outline-none focus:ring-2 focus:ring-[#1C50A3] text-lg font-medium placeholder:text-[#1C50A3]"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email Address"
                autoComplete="email"
                required
              />
              <span className="absolute inset-y-0 left-0 pl-3 flex items-center text-[#1C50A3]">
                <FontAwesomeIcon icon={faEnvelope} />
              </span>
            </div>

            <button
              type="submit"
              className="w-full bg-[#1C50A3] text-white p-2 rounded-lg transition duration-200 text-lg font-medium"
            >
              Send Reset Link
            </button>
          </form>
        </div>
      </div>

      {/* Success Modal */}
      {showSuccess && (
        <div className="fixed top-4 right-4 bg-[#1C50A3] text-white p-4 rounded-lg shadow-lg z-50">
          <p className="text-center font-semibold">{message}</p>
        </div>
      )}

      {/* Error Modal */}
      {showError && (
        <div className="fixed top-4 right-4 bg-red-500 text-white p-4 rounded-lg shadow-lg z-50">
          <p className="text-center font-semibold">{error}</p>
        </div>
      )}
    </div>
  );
}

export default ForgotPassword;
